<template>
	<div v-if="showMinimalTracker" class="order-tracker-minimal-container">
		<div class="icon-wrapper" :class="styleIcon('ordering')">
			<BaseIcon
				:editStroke="false"
				:isCustom="true"
				:icon="getIcon('ordering')"
				:classNames="getClassNamesForIcon('ordering')"/>
			<span class="icon-label">
				{{ getTrackerLabel('ordering') }}
			</span>
		</div>
		<div class="icon-wrapper" :class="styleIcon('placed')">
			<BaseIcon
				:editStroke="false"
				:isCustom="true"
				:icon="getIcon('placed')"
				:classNames="getClassNamesForIcon('placed')"/>
			<span class="icon-label">
				{{ getTrackerLabel('placed') }}
			</span>
		</div>
		<div class="icon-wrapper" :class="styleIcon('making')">
			<BaseIcon
				:editStroke="false"
				:isCustom="true"
				:icon="getIcon('making')"
				:classNames="getClassNamesForIcon('making')"/>
			<span class="icon-label">
				{{ getTrackerLabel('making') }}
			</span>
		</div>
		<div v-if="!isOrderDelivery" class="icon-wrapper" :class="styleIcon('pickup')">
			<BaseIcon
				:editStroke="false"
				:isCustom="true"
				:icon="getIcon('pickup')"
				:classNames="getClassNamesForIcon('pickup')"/>
			<span class="icon-label">
				{{ getTrackerLabel('pickup') }}
			</span>
		</div>
		<div v-if="isOrderDelivery" class="icon-wrapper" :class="styleIcon('delivering')">
			<BaseIcon
				:editStroke="false"
				:isCustom="true"
				:icon="getIcon('delivering')"
				:classNames="getClassNamesForIcon('delivering')"/>
			<span class="icon-label">
				<template v-if="isStatusDelivering">
					{{ getTrackerLabel('delivering') }}
				</template>
				<template v-if="!isStatusDelivering">
					Delivered!
				</template>
			</span>
		</div>
	</div>
</template>

<script>
	// TODO refactor template
	import trackerMixin from '@Mixin/trackerMixin';
	import orderMixin from '@Mixin/orderMixin';
	export default {
		mixins: [
			trackerMixin,
			orderMixin
		],
		components: {},
		props: {},
		computed: {
			showMinimalTracker() {
				const appConstants = this.$appConstants;
				const isMinimal = (appConstants.checkout.minimal === '1');
				return this.getTrackerActive && isMinimal;
			}
		},
		methods: {
			getIcon(name) {
				return this.getTrackerIcon(name);
			},
			styleIcon(name) {
				return this.resolveTrackerPositionForName(name);
			},
			getClassNamesForIcon(name) {
				const iconName = this.getTrackerIcon(name);
				const position = this.resolveTrackerPositionForName(name);
				return [
					'tracker',
					`${iconName}-icon`,
					`${position}-pos`,
				];
			},
			getTrackerIcon(name) {
				const $appConstants = this.$appConstants;
				const trackerIcons = $appConstants.tracker.icons;
				return trackerIcons[name];
			},
			getTrackerLabel(name) {
				const $appConstants = this.$appConstants;
				const trackerLabels = $appConstants.tracker.labels;
				return trackerLabels[name];
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	.order-tracker-minimal-container {
		display: flex;
		justify-content: space-evenly;
		width: 100%;
		max-width: 330px;
		font-family: sans-serif;
	}
	.icon-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 2.5em;
		height: 2.5em;
		background-color: $landingPageBackground;
		border: 1px solid $greyOutline;
		border-radius: 50%;
		transition: .3s all ease-out;
		z-index: 1;
		&::before {
			content: '';
			position: absolute;
			width: 3em;
			height: 2px;
			left: 100%;
			background-color: $greyOutline;
			z-index: 0;
		}
		&:last-of-type {
			&::before {
				width: 0;
			}
		}
		.icon-label {
			position: absolute;
			top: 45px;

			color: $navigationItemColor;
			opacity: 0;

			font-size: 10pt;
			font-weight: bold;
			transition: .3s opacity ease-out;
		}
		&.active {
			border: 1px solid $navigationItemColor;
			background-color: $navigationItemColor;
			&::before {
				background-color: $navigationItemColor;
			}
			&.current {
				.icon-label {
					opacity: 1;
				}
			}
		}
	}
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/order-confirmation/OrderTrackerMinimal.vue